module.exports = __webpack_public_path__ + "static/media/ic_search.9897f26f.svg";